import Localization from "@/Localization"
import { InfoViewModel, SiteViewModel } from "@/TemsManagerWebInterface"
import AuthorizationView from "Tems/Security/AuthorizationView";
import Authorization, { LoginResponse } from "Tems/Security/Authorization";
import TemsPolicy from "Tems/Security/TemsPolicy";
import TemsGateway from "Tems/Gateway";
import TemsWebEvents from '@/TemsWebEvents';
import JqueryLoginModal from "@/JqueryLoginModal";

export default class ManagerView {
    protected authorization: Authorization;
    protected authorizationView: AuthorizationView;
    protected gateway: TemsGateway;

    private siteUpdateTimeoutHandle: number;
    private siteUpdateRunning = false;
    private currentSite: SiteViewModel;

    protected isMaintenanceWatcherRunning = false;
    protected updateInterval: number;

    public returnUrl: string = null;

    /**
     * If true, this forces an update of property "Recorder" on InfoViewModel for every update. Otherwise the property is only updated on log in.
     */
    protected get invalidateRecorderConfig(): boolean {
        return false;
    }

    public static get MODAL_SHOW_BACKDROP(): ModalOptions {
        return {
            "backdrop": "true",
            "keyboard": true,
            "show": true,
        };
    }
    public static get MODAL_SHOW_NO_BACKDROP(): ModalOptions {
        return {
            "backdrop": "static",
            "keyboard": false,
            "show": true,
        };
    }

    init() {
        this.authorization = new Authorization();
        this.authorization.onChangeUser(() => {
            TemsWebEvents.publishEvent(TemsWebEvents.UserLevelChanged, []);
        });

        var loginPromise = this.authorization.autoLogin([TemsPolicy.OperatorPolicy]);
        var langPromise = fetch(`/Home/GetTranslationsJson?v=1`, {
            method: "GET",
            headers: {
                Accept: "application/json; charset=utf-8",
                "Content-Type": "application/json; charset=utf-8"
            }
        });
        loginPromise.then((response) => {
            if (response.success && response.loginRequired && window.location.pathname == '/') {
                location.reload();
            }
        });

        $(document).ready(() => {
            Promise.all([langPromise, loginPromise]).then(values => {
                var response: LoginResponse = values[1];
                if (response.success && response.loginRequired) {
                    // do nothing
                } else if (values[0].ok) {
                    values[0].json().then(data => {
                        Localization.Culture = data.DesiredLanguage;
                        Localization.setResourceStrings(data.Labels);
                        var isLoggedIn = values[1] != null;
                        this.authorizationView = new AuthorizationView(
                            this.authorization,
                            new JqueryLoginModal(),
                            Localization.resourceStrings.LoginModal_ErrorRecorderNotAvailable
                        );
                        if (!isLoggedIn) {
                            this.authorizationView.showLogin();
                        } else {
                            this.gateway = new TemsGateway(this.authorizationView);

                            this.handleDocumentReady();
                            this.startSiteUpdate();
                        }
                    });
                } else {
                    this.handleSiteNoTranslations();
                }
            });
        });
    }

    handleDocumentReady(): void {
    }

    /**
     * Called periodically with the newest version of the InfoViewModel.
     * @param model Latest version of the InfoViewModel
     */
    handleSiteUpdate(model: InfoViewModel): void {
    }

    /**
     * Called when the periodic update of the InfoViewModel failes
     * @param errorMessage Error message of the 
     */
    handleSiteUpdateError(errorMessage: string): void {
    }

    handleSiteNoTranslations(): void {
    }

    /**
     * Immediately updates the InfoViewModel instead of waiting for the periodic update. The periodic update process is restarted afterwards.
     */
    public forceSiteModelUpdate() {
        // we can't force, if there is already a request pending, maybe we should call ourselves with a very thight timeout...
        if (!this.siteUpdateRunning) {
            clearTimeout(this.siteUpdateTimeoutHandle); // clear any potentially pending updates
            this.startSiteUpdate();
        }
    }

    private startSiteUpdate() {
        if (!this.isMaintenanceWatcherRunning) {
            this.siteUpdateRunning = true;

            return this.gateway.get(`/api/Info/GetInfoViewModel${this.invalidateRecorderConfig ? '/true' : ''}`, {}, [TemsPolicy.OperatorPolicy]).then((response) => {
                if (response.ok) {
                    response.json().then((newModel: InfoViewModel) => {

                        if (newModel.SiteConfigId != null) {
                            let isSiteReloadRequired =
                                this.currentSite == null ||
                                this.currentSite.Id != newModel.SiteConfigId ||
                                this.currentSite.VersionHashCode != newModel.SiteConfigVersionHashCode;

                            if (isSiteReloadRequired) {
                                return this.gateway.get("/api/Info/GetSiteViewModel", {}, [TemsPolicy.OperatorPolicy]).then((response) => {
                                    if (response.ok) {
                                        response.json().then((newSite: SiteViewModel) => {
                                            this.currentSite = newSite;
                                            this.siteUpdateRunning = false;
                                            newModel.Site = newSite;
                                            this.handleSiteUpdate(newModel);

                                        });
                                    } else {
                                        return response.json().then(error => {
                                            if (response.status === 401) {
                                                return this.authorizationView.showLogin();
                                            } else {
                                                this.handleSiteUpdateError(error.Message);
                                            }
                                        });
                                    }
                                });
                            }
                        } else {
                            this.currentSite = null;
                        }

                        this.siteUpdateRunning = false;
                        newModel.Site = this.currentSite;
                        this.handleSiteUpdate(newModel);
                    });
                } else {
                    return response.json().then(error => {
                        this.siteUpdateRunning = false;
                        if (response.status === 401) {
                            return this.authorizationView.showLogin();
                        } else {
                            this.handleSiteUpdateError(error.Message);
                        }
                    });
                }
                // Finally
            }).catch(_ => { }).then(() => {
                this.siteUpdateTimeoutHandle = window.setTimeout(() => this.startSiteUpdate(), this.updateInterval);
            });
        } else {
            this.siteUpdateTimeoutHandle = window.setTimeout(() => this.startSiteUpdate(), this.updateInterval);
        }
    }
}

